var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimMilesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 160,
    viewBox: "0 0 375 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3283",
    "data-name": "Rectangle 3283",
    width: 375,
    height: 160,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 14.843,
    height: 14.843,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28774",
    "data-name": "Group 28774",
    transform: "translate(0 -313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 375,
    height: 160,
    transform: "translate(0 313)",
    fill: "#ffd755"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0 313)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3253",
    "data-name": "Rectangle 3253",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(92.58 132.92) rotate(-45)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3255",
    "data-name": "Rectangle 3255",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(27.115 41.223) rotate(-27.97)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3256",
    "data-name": "Rectangle 3256",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(352.68 18.3) rotate(-30)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3257",
    "data-name": "Rectangle 3257",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(138.004 37.956) rotate(-30)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3258",
    "data-name": "Rectangle 3258",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(221.259 19.214) rotate(-30)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3259",
    "data-name": "Rectangle 3259",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(180.536 94.961) rotate(-30)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3261",
    "data-name": "Rectangle 3261",
    width: 10.197,
    height: 10.197,
    rx: 2.64,
    transform: "translate(331.164 116.879) rotate(-30)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38043",
    "data-name": "Path 38043",
    d: "M63.8,83.69s-18.937,16.752-26.22,40.787-5.1,48.8-5.1,48.8H39.04s3.642-32.775,10.2-50.255S69.4,87.332,69.4,87.332Z",
    transform: "translate(1.831 -40.355)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38044",
    "data-name": "Path 38044",
    d: "M84.937,76.875l2.185-2.185S113.342,77.6,109.7,98.725,87.122,118.39,95.862,123.488s10.2,8.012,9.468,14.567.648,13.627-11.7,15.55S68.12,160.633,76.889,170.83a118.457,118.457,0,0,0,19.133,17.48l-3.977,5.353S67.457,183.212,67.093,170.83s4.734-18.937,20.029-22.578,19.665-5.1,9.468-11.653-17.516-16.533-8.026-25.747S114.071,87.8,84.937,76.875Z",
    transform: "matrix(0.616, 0.788, -0.788, 0.616, 215.133, -77.759)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38045",
    "data-name": "Path 38045",
    d: "M181.6,93.06l2.928-4.37s27.662,2.185,27.662,44.428-4.37,65.55-4.37,65.55l-5.448-1.2s5.448-59.978.35-76S192.525,98.887,181.6,93.06Z",
    transform: "translate(83.513 6.875) rotate(-30)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38046",
    "data-name": "Path 38046",
    d: "M146.091,110.69l4.37,1.457s-10.2,10.925-8.74,15.3,16.752,3.416,18.937,7.174-3.642,10.306-13.11,16.133-.728,6.475,13.11,6.875,13.838,10.6,9.468,18.616-10.372,10.2-10.372,10.2l-.612-2.185s13.889-14.96,9.519-19.5-18.492,1.3-27.094-6.723,19.155-16.752,13.292-17.48-20.554-3.176-20.852-14.7,12.076-15.164,12.076-15.164Z",
    transform: "translate(127.187 -82.645)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28772",
    "data-name": "Group 28772",
    transform: "translate(235.188 110.866)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102",
    "data-name": "Path 38102",
    d: "M9.923,5.425l4.385,1.282a.744.744,0,0,1,0,1.427L9.923,9.417a.744.744,0,0,0-.505.5L8.136,14.308a.743.743,0,0,1-1.427,0L5.426,9.922a.744.744,0,0,0-.5-.5L.536,8.135a.744.744,0,0,1,0-1.427L4.921,5.425a.744.744,0,0,0,.5-.5L6.709.535a.743.743,0,0,1,1.427,0L9.418,4.92a.744.744,0,0,0,.505.5",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28773",
    "data-name": "Group 28773",
    transform: "translate(90.454 13.202)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-2",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-2",
    "data-name": "Path 38102",
    d: "M9.923,5.425l4.385,1.282a.744.744,0,0,1,0,1.427L9.923,9.417a.744.744,0,0,0-.505.5L8.136,14.308a.743.743,0,0,1-1.427,0L5.426,9.922a.744.744,0,0,0-.5-.5L.536,8.135a.744.744,0,0,1,0-1.427L4.921,5.425a.744.744,0,0,0,.5-.5L6.709.535a.743.743,0,0,1,1.427,0L9.418,4.92a.744.744,0,0,0,.505.5",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimMilesBg);
export default __webpack_public_path__ + "static/media/claim-miles-bg.47b3272a4c9c9bf4585a629e51bdd9e6.svg";
export { ForwardRef as ReactComponent };